var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { StepperFormFooter, StepperFormFooterProps } from "./Footer";
import Heading from "./Heading";
import Hint from "./Hint";
import Loader from "./Loader";
import Text from "./Text";
import React from 'react';
import { css, mq, styled } from "../utils";
var Card = styled.div(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    background-color: ", ";\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n    min-height: 550px;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    background-color: ", ";\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n    min-height: 550px;\n  "])), colors.white);
}, mq({
    borderRadius: [0, '5px'],
}));
var Content = styled.div(mq({
    flex: 1,
    padding: ['2rem  1rem', '4rem 5rem', '2rem  4rem'],
}));
var Icon = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 66px;\n  width: auto;\n  margin: 0 auto 2rem;\n\n  ", "\n"], ["\n  height: 66px;\n  width: auto;\n  margin: 0 auto 2rem;\n\n  ",
    "\n"])), mq({
    display: ['none', 'none', 'block'],
}));
var Title = styled(Heading.Heading2)(function (_a) {
    var font = _a.theme.font;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: 0.5rem;\n    position: relative;\n    font-weight: ", ";\n\n    ", "\n  "], ["\n    margin-bottom: 0.5rem;\n    position: relative;\n    font-weight: ", ";\n\n    ",
        "\n  "])), font.weight.normal, mq({
        padding: ['0 2rem', '0 2rem', '0'],
        textAlign: ['center', 'center', 'left'],
    }));
});
var StyledHint = styled(Hint)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 0 0.5rem;\n"], ["\n  margin: 0 0.5rem;\n"])));
var Description = styled(Text)(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin: 0;\n    color: ", ";\n  "], ["\n    margin: 0;\n    color: ", ";\n  "])), colors.lighterBlack);
}, mq({
    textAlign: ['center', 'center', 'left'],
}));
var StyledStepperFormFooter = styled(StepperFormFooter)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  && {\n    height: 56px;\n    display: flex;\n  }\n\n  ", "\n"], ["\n  && {\n    height: 56px;\n    display: flex;\n  }\n\n  ",
    "\n"])), mq({
    position: ['fixed', 'static'],
    borderBottomLeftRadius: [0, '5px'],
    borderBottomRightRadius: [0, '5px'],
    zIndex: [10, 'unset'],
    bottom: [0, 'unset'],
    right: [0, 'unset'],
    left: [0, 'unset'],
}));
var Children = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-top: 1.5rem;\n"], ["\n  margin-top: 1.5rem;\n"])));
var WizardCard = function (_a) {
    var icon = _a.icon, title = _a.title, description = _a.description, children = _a.children, className = _a.className, hint = _a.hint, isLoading = _a.isLoading, stepperFormFooterProps = __rest(_a, ["icon", "title", "description", "children", "className", "hint", "isLoading"]);
    return (React.createElement(Card, { "data-component": "WizardCard" },
        React.createElement(Content, { className: className },
            icon && React.createElement(Icon, { src: icon, alt: "icon" }),
            title && (React.createElement(Title, null,
                title,
                hint && React.createElement(StyledHint, null, hint))),
            description && React.createElement(Description, null, description),
            isLoading && React.createElement(Loader, { overlay: true }),
            React.createElement(Children, null, children)),
        React.createElement(StyledStepperFormFooter, __assign({}, stepperFormFooterProps))));
};
export default WizardCard;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=WizardCard.js.map